import React, { useState, useEffect } from 'react';
import { MessageSquare, X } from 'lucide-react';
import * as S from './SuggestionsPopup.styles';

const defaultSuggestions = [
  'How to develop a duplex?',
  'What are the guidlines to develop a sales office?',
  'How do I build a dwelling unit?',
];

export const SuggestionsPopup = ({
  isOpen,
  onClose,
  suggestions = defaultSuggestions,
  onSuggestionClick,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
      // Prevent body scroll when popup is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // Match animation duration
  };

  const handleBackdropClick = () => {
    handleClose();
  };

  const handleSuggestionClick = (suggestion) => {
    if (onSuggestionClick) {
      onSuggestionClick(suggestion);
    }
    handleClose();
  };

  if (!isOpen && !isClosing) return null;

  return (
    <>
      <S.Backdrop $isClosing={isClosing} onClick={handleBackdropClick} />
      <S.PopupOverlay $isClosing={isClosing}>
        <S.PopupContainer>
          <S.PopupHeader>
            <S.HeaderContent>
              <S.Title>Quick Suggestions</S.Title>
              <S.Subtitle>Choose one or ask your own question</S.Subtitle>
            </S.HeaderContent>
            <S.CloseButton onClick={handleClose} aria-label="Close suggestions">
              <X />
            </S.CloseButton>
          </S.PopupHeader>

          <S.SuggestionsContainer>
            {suggestions.map((suggestion, index) => (
              <S.SuggestionCard key={index} onClick={() => handleSuggestionClick(suggestion)}>
                <S.SuggestionText>{suggestion}</S.SuggestionText>
                <S.SuggestionIcon>
                  <MessageSquare />
                </S.SuggestionIcon>
              </S.SuggestionCard>
            ))}
          </S.SuggestionsContainer>
        </S.PopupContainer>
      </S.PopupOverlay>
    </>
  );
};
